import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BackendService, PublicLinkPasswordService, Query, WidgetQueueProxyService } from '@hub-components';

export interface PageQuerySignature {
  auth: string;
  selection: any;
  metric_selection: any;
}

@Injectable({
  providedIn: 'root',
})
export class PageQuerySigningService {
  constructor(
    private backendService: BackendService,
    private publicLinkPasswordService: PublicLinkPasswordService,
    private widgetQueueProxyService: WidgetQueueProxyService,
  ) {}

  sign(widgetQuery: Query, pageQuery: Query, shownQuery?: Query): Observable<PageQuerySignature> {
    const body = { widget_query: widgetQuery.asJson(), page_query: pageQuery.asJson(), ...(shownQuery && { shown_query: shownQuery.asJson() }) };
    const options = { skipLoader: true, throwErrors: true };
    const request = widgetQuery.publicId
      ? this.backendService.create(`s/${widgetQuery.publicId}/sign_page_query`, { ...body, password: this.publicLinkPasswordService.getPassword(widgetQuery.publicId) }, options)
      : this.backendService.create(`shared_dashboards/${widgetQuery.shareId}/sign_page_query`, body, options);

    return this.widgetQueueProxyService.trackRequest(request).pipe(map(({ auth, selection, metric_selection }) => ({ auth, selection, metric_selection })));
  }
}
